import './Description.scss';
import { InitiativeMedia } from './Media';
import { InitiativeSection } from './general';
import { JiraSummary } from './jira/JiraSummary';
import { TextEditor } from '@periscopes/general/editor';
import { When } from 'react-if';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useAction, useFeatureFlag } from '@hooks';

export interface InitiativeDescriptionProps {
	description: string | null | undefined;
	initiativeId: number;
}

export const InitiativeDescription: React.FC<InitiativeDescriptionProps> = ({ description, initiativeId }) => {
	const patchInitiative = useAction(coreActions.requestPatchCoreInitiativesById);
	const jiraEnabled = useFeatureFlag(FeatureFlag.JiraIntegration);

	const handleOnSave = useCallback(
		(updatedDescription: string) => {
			patchInitiative({
				initiativeId: initiativeId,
				patchInitiativeDescription: {
					description: updatedDescription
				}
			});
		},
		[ initiativeId, patchInitiative ]
	);

	return (
		<InitiativeSection
			id='initiative-description'
			title={ COPY_SPECIFIC.DESCRIPTION }>
			<TextEditor
				canBeEmpty
				content={ description ?? '' }
				onSave={ handleOnSave }
				placeholder={ PLACEHOLDERS_COPY.ADD_DESCRIPTION }
				saveOnBlur />
			<InitiativeMedia initiativeId={ initiativeId } />
			<When condition={ jiraEnabled }>
				<JiraSummary initiativeId={ initiativeId } />
			</When>
		</InitiativeSection>
	);
};
